<template>
  <section class="approvals-section">
    <article class="approvals-section__panel">
      <div class="approvals-section__head">
        <div>
          <h3>Listado de avales proceso de grado</h3>
          <p>Consulta el estado de los avales y paz y salvos asociados al proceso de grado.</p>
        </div>

        <span class="approvals-section__summary">
          {{ approvals.length }} aval(es)
        </span>
      </div>

      <div class="approvals-section__list">
        <article
          v-for="approvalItem in approvals"
          :key="approvalItem.id"
          class="approvals-section__row"
        >
          <div>
            <strong class="approvals-section__title">{{ approvalItem.name }}</strong>
            <p class="approvals-section__owner">{{ approvalItem.owner }}</p>
            <p class="approvals-section__note">{{ approvalItem.note }}</p>
          </div>

          <div class="approvals-section__meta">
            <span>{{ approvalItem.updatedAt }}</span>
            <span class="approvals-section__status" :class="statusClass(approvalItem.status)">
              {{ approvalItem.status }}
            </span>
          </div>
        </article>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: 'GraduationApprovalsSection',
  props: {
    approvals: {
      type: Array,
      required: true,
    },
  },
  methods: {
    statusClass (status) {
      if (status === 'Aprobado') {
        return 'is-success'
      }

      if (status === 'Con novedad') {
        return 'is-danger'
      }

      return 'is-warning'
    },
  },
}
</script>

<style scoped>
.approvals-section__panel {
  background: #fff;
  border: 1px solid var(--ibero-border);
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 22px;
}

.approvals-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.approvals-section__head h3 {
  margin: 0;
  color: var(--ibero-primary);
  font-size: 19px;
  font-weight: 700;
}

.approvals-section__head p {
  margin: 8px 0 0;
  color: var(--ibero-muted);
  font-size: 14px;
}

.approvals-section__summary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: var(--ibero-primary-soft);
  color: var(--ibero-primary);
  font-size: 12px;
  font-weight: 700;
}

.approvals-section__list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 22px;
}

.approvals-section__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px;
  border: 1px solid var(--ibero-border);
  border-radius: 10px;
  background: #fff;
}

.approvals-section__title {
  display: block;
  color: var(--ibero-text);
  font-size: 16px;
}

.approvals-section__owner,
.approvals-section__note {
  margin: 8px 0 0;
  color: var(--ibero-muted);
  font-size: 14px;
}

.approvals-section__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  color: var(--ibero-muted);
  font-size: 13px;
}

.approvals-section__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 130px;
  padding: 10px 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}

.approvals-section__status.is-success {
  background: rgba(34, 139, 34, 0.12);
  color: #206a20;
}

.approvals-section__status.is-danger {
  background: rgba(220, 38, 38, 0.1);
  color: #b91c1c;
}

.approvals-section__status.is-warning {
  background: rgba(242, 169, 0, 0.16);
  color: #8a6200;
}

@media (max-width: 760px) {
  .approvals-section__head,
  .approvals-section__row {
    flex-direction: column;
    align-items: flex-start;
  }

  .approvals-section__meta {
    align-items: flex-start;
  }
}
</style>
